<template>
  <div class="comp-xl-price-sheet">
    <div class="price-sheet-title">
      <span>{{ $t('报价单列表') }}</span>
      <!-- <jw-link v-if="(data.entity === 2 && data.permission == 1) || data.entity === 3" @click="addPriceSheet">新增报价单</jw-link> -->
      <span v-permission="data.entity === 2 ? ['006001170'] : ['007001180']">
        <jw-link v-if="data.permission == 1" @click="addPriceSheet"> {{ $t('新增') }} </jw-link>
      </span>
    </div>
    <jw-space direction="vertical" fill>
      <jw-table sticky-header :loading="loading" :data="data.pricesheetList" :pagination="data.pagination" :columns="data.columns" @pageChange="pageChange">
        <!-- 报价单编号插槽--详情 -->
        <template #priceSheetCode="{ record }">
          <jw-link @click="toDetails(record, 'priceSheet')">{{ record?.priceSheetCode || '-' }}</jw-link>
        </template>
        <!-- 客户名称插槽--详情 -->
        <template #customerId="{ record }">
          <jw-link @click="toDetails(record, 'client')" v-if="record.customerId?.value">{{ record.customerId?.label }}</jw-link>
          <template v-else>-</template>
        </template>
        <!-- 商机名称插槽--详情 -->
        <template #opportunityId="{ record }">
          <jw-link @click="toDetails(record, 'opportunity')" v-if="record.opportunityId?.value">{{ record.opportunityId?.label }}</jw-link>
          <template v-else>-</template>
        </template>
        <!-- 生命状态 -->
        <template #status="{ record }">
          <xl-status :status="record.status" :statusOrigin="record.statusOrigin"></xl-status>
        </template>
        <!-- 币种 -->
        <template #currencyType="{ record }">
          <span>{{ record?.currencyLabel || '-' }}</span>
        </template>
        <!-- 报价单金额 -->
        <template #amount="{ record }">
          <span>{{ tools.getPrice(record?.amount) || '-' }}</span>
        </template>
        <!-- 负责人插槽 -->
        <template #chargePerson="{ record }">
          <xl-avatar :avatar="{ name: record?.chargeUserInfo?.userName || $t('系统'), url: record?.chargeUserInfo?.avatar, id: record?.chargeUserInfo?.userId }" :size="22" />
        </template>
        <!-- 创建人插槽 -->
        <template #createUser="{ record }">
          <xl-avatar :avatar="{ name: record?.addUserInfo?.userName || $t('系统'), url: record?.addUserInfo?.avatar, id: record?.addUserInfo?.userId }" :size="22" />
        </template>
        <!-- 最后更新人插槽 -->
        <template #updateUser="{ record }">
          <xl-avatar :avatar="{ name: record?.updateUserInfo?.userName || $t('系统'), url: record?.updateUserInfo?.avatar, id: record?.updateUserInfo?.userId }" :size="22" />
        </template>
      </jw-table>
    </jw-space>
    <!--主对象公共详情  S-->
    <ly-detail ref="detailRef"></ly-detail>
  </div>
</template>

<script setup>
import { reactive, ref, h, provide, computed, inject, watch } from 'vue';
import { opportunityService } from '@/api/';
// import useXlTable from '@/hooks/xl-table';
import useLoading from '@/hooks/loading';
import useFields from '@/hooks/fields';
import { useRouter } from 'vue-router';
import { checkboxFieldList, huaYingOrdId } from '@/utils/const';
import { Message } from '@arco-design/web-vue';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
import { usePricesheetStore, useUserStore, useOrderStore, useContractStore } from '@/store';

const { t } = useI18n();
const data = reactive({
  fieldList: [],
  type: 6,
  id: null,
  entity: null,
  record: inject('detailParams')?.record,
  permission: inject('detailParams')?.permission, //协作人权限
  customerId: inject('detailParams').customerId,
  opportunityId: null,
  pricesheetList: [],
  page: 1,
  pagination: {
    size: 1,
    current: 1,
    pageSize: 10,
    total: 0,
    showPageSize: false, // 是否显示数据条数选择器
    showTotal: true // 是否显示数据总数
  },
  customPermission: true //客户是否有协作权限
});
const { loading, setLoading } = useLoading(true);
const { userInfo } = useUserStore(); //用户信息
const getPricesheetStore = usePricesheetStore(); //报价单store
const getContract = useContractStore(); //合同store
const getOrder = useOrderStore(); //订单store

const detailRef = ref(); //公共详情页
const router = useRouter();
// 根据ID获取报价单列表
const getList = async (params) => {
  data.pricesheetList = [];
  setLoading(true);
  await getPricesheetStore
    .getPricesheetLists(params)
    .then((res) => {
      console.log(res);
    })
    .finally(() => {
      setLoading(false);
    });
};
//分页
const pageChange = (current) => {
  data.page = current;
  data.pagination.current = current;
  getList({ page: data.page, pageSize: data.pagination.pageSize, entity: data.entity, id: data.id });
};
watch(
  () => getPricesheetStore.pricesheetList,
  (v) => {
    console.log(1201, 'vvvv', v);
    data.pricesheetList = v?.records;
    data.pagination.total = v?.total;
  },
  {
    deep: true
  }
);

// 表格表头数据字段
const { enableList, searchList, getFields, getFieldLabel } = useFields();
// 获取所有字段值,生成表格头部
const getField = async (entity, id) => {
  // setLoading(false);
  console.log(89, entity, id);
  data.entity = entity;
  data.id = id;
  getContract.updateRefresh(false);
  getOrder.updateRefresh(false);
  getPricesheetStore.updateRefresh(true);
  await getFields({ id: data.type });
  console.log('获取所有字段值：生成表格头部', enableList, searchList, getFieldLabel);
  data.fieldList = enableList;
  data.columns = getColumns(entity);
  console.log(222, data.fieldList, data.columns);
  // setLoadListParams({ entity, id });
  getList({ page: data.page, pageSize: data.pagination.pageSize, entity: data.entity, id: data.id });
  // loadTList(1);
};

// 从所有字段中获取表格头部标题
const getColumns = (entity) => {
  const list = [];
  const fieldList = data.fieldList?.filter((i) => (checkboxFieldList.indexOf(i.fieldKey) == -1 && entity == 2 && i.fieldKey !== 'customerId') || (entity == 3 && i.fieldKey !== 'opportunityId'));
  console.log(61, fieldList, entity);
  fieldList?.forEach((item) => {
    const k = item.fieldKey; //字段标识
    const render = ({ record }) => {
      console.log(record);
      let fieldKey = record[k];
      if (item.type === 2) {
        fieldKey = record?.['customFields']?.[k];
      }
      if (fieldKey || fieldKey === 0) {
        if (item.fieldType === 9) {
          if (fieldKey && fieldKey !== '{}') {
            return Object.values(JSON.parse(fieldKey))?.join('/');
          } else {
            return '-';
          }
        } else if (item.fieldType === 6) {
          if (fieldKey instanceof Array) {
            // console.log('查看人员头像303', fieldKey);
            return fieldKey?.map((v) => v.name)?.join(',');
          } else {
            return '-';
          }
        } else if ([2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
          // console.log(366, item?.fieldExtObj, fieldKey, item?.fieldExtObj[fieldKey]?.label);
          return getFieldLabel(fieldKey, item.fieldExt, item.fieldType);
        } else if (item.fieldType === 11) {
          return h(
            'a',
            {
              style: {
                color: '#165dff',
                cursor: 'pointer'
              },
              href: fieldKey,
              target: '_blank'
            },
            '查看'
          );
        } else if (item.fieldType === 12) {
          return fieldKey?.label || '-';
        } else {
          return fieldKey?.label ?? fieldKey?.value ?? fieldKey ?? '-';
        }
      } else {
        return '-';
      }
    };

    const colType = {
      title: item.fieldName,
      dataIndex: k,
      ellipsis: true,
      tooltip: true
    };
    if (item.type === 1) {
      colType.colType = t('基础字段');
    }
    if (item.type === 2) {
      colType.dataIndex = `${k}Custom`;
    }
    const width = item.fieldName.length <= 5 ? 120 : item.fieldName.length * 30;
    if (k === 'customerId' || k === 'opportunityId' || k === 'priceSheetCode') {
      //报价单编号--产品名称-商机名称
      list.push({ ...colType, slotName: k, width: 220 });
    } else if (k === 'gmtUpdated' || k === 'gmtCreated' || k === 'priceDate') {
      list.push({ ...colType, width: 180, render });
    } else if (k === 'createUser' || k === 'updateUser' || k === 'chargePerson' || k === 'status' || k === 'amount' || k === 'currencyType') {
      list.push({ ...colType, slotName: k, width: 120 });
    } else {
      list.push({ ...colType, width, render });
    }
  });
  console.log(293, list);
  return list;
};
// 判断商机关联的客户是否有权限(负责人或协作人)
const getCustomPermission = async (customerId, type) => {
  try {
    const params = {
      entity: type,
      id: customerId
    };
    const json = await opportunityService.getCustomPermission(params);
    console.log(237, json);
    if (!json.error) {
      data.customPermission = json.result;
    } else {
      Message.error(json.error?.msg || t('获取客户协作权限失败'));
    }
  } catch (e) {
    console.log(e);
    Message.error(e.message || e.statusText || t('获取客户协作权限失败'));
  }
};

// 跳转新建报价单
const addPriceSheet = async () => {
  console.log('253跳转到新建报价单页面', data.record);
  const customerId = data.entity == 2 ? data.record.find((v) => v.fieldKey === 'id')?.fieldValue : data.record.find((v) => v.fieldKey === 'customerId')?.fieldValue?.value;
  const opportunityId = data.record.find((v) => data.entity === 3 && v.fieldKey === 'id')?.fieldValue;
  const qccId = data.record.find((v) => v.fieldKey === 'qccId')?.fieldValue;
  console.log(253, customerId, opportunityId);
  if (data.entity === 2 && !qccId && userInfo?.orgId != huaYingOrdId) {
    //客户未关联工商信息
    Message.warning(t('tips.addPriceErr'));
    return;
  } else if (data.entity === 3) {
    // 商机传递关联的客户ID和客户的entity
    await getCustomPermission(customerId, 2);
    if (!customerId) {
      //商机未关联客户
      Message.warning(t('tips.addPriceError'));
      return;
    } else if (!data.customPermission) {
      // 商机关联了客户，但是没有客户操作权限
      Message.warning(t('tips.noPrimisson'));
      return;
    }
  }
  router.push({
    name: 'update-price-sheet',
    params: { id: -1 },
    query: { sign: 1, entity: data.entity, customerId, opportunityId }
  });
};
// 去详情页面
const toDetails = (record, type) => {
  console.log(160, record);

  if (type === 'priceSheet') {
    data.id = record.id;
  } else if (type === 'client') {
    data.id = record.customerId?.value;
  } else if (type === 'opportunity') {
    data.id = record.opportunityId?.value;
  }
  detailRef.value?.openDialog();
};
provide('globalParams', {
  id: computed(() => data.id)
});
defineExpose({ getField });
</script>
<style scoped lang="less">
@import './xl-price-sheet.less';
</style>
